import { AutogenModelInStateDistance, AutogenRowInStateDistance } from "./autogen/AutogenModelInStateDistance";

export class ModelInStateDistance extends AutogenModelInStateDistance<RowInStateDistance> {
	constructor() {
		super(RowInStateDistance);
	}
}

export class RowInStateDistance extends AutogenRowInStateDistance {
}